import TrendingTable from './TrendingTable';

export default TrendingTable;
